<script>
import TweenMax, {Expo} from 'gsap/TweenMax';
import UiButton from '@/components/ui/Button';
import config from '@/config';

export default {
  name: 'BeforeEnter',
  components: {
    UiButton
  },
  mounted() {
    this.$store.dispatch('Sound/FADE', {
      fromSound: 'fond',
      volumeFrom: 0,
      volumeTo: config.SOUNDS.fond.volume,
      duration: 2
    });
    
    //preload future stuff
    if(!this.$store.getters['Preload/hasPreload']('BeforeEnter')) {
      this.$store.dispatch('Preload/START', "BeforeEnter");
    }
    
    TweenMax.from(this.$el.querySelector(".text"), 1, {alpha:0, y:20, ease:Expo.easeOut, delay:.3}); 
    TweenMax.from(this.$el.querySelector(".Headset"), 1, {alpha:0, y:20, ease:Expo.easeOut, delay:.8}); 
    TweenMax.from(this.$refs.Exit.$el, .5, {alpha:0, y:20, ease:Expo.easeOut, delay:1.4}); 
  },
  methods: {
    exit(){
      
      TweenMax.to(this.$el, 2, {alpha:0, ease:Expo.easeOut, onComplete: () => {
        this.$router.push({name:"Prelude", params: { id:"born" } });
      }});
    },
  }
}
</script>

<template>
  <div class="BeforeEnter">
    <div class='panel'>
      <p class="text" v-html="$t('intro.headset')" />
      <img class="-svg Headset" src="/assets/ecouteurs.gif" alt="iconEcouteurs"/>
      <ui-button ref="Exit" class="next-buttton" v-on:pressed="exit" />
    </div>
  </div>
</template>


<style scoped lang="scss">
.BeforeEnter {
  position: relative;
  width: 100%;
  height: calc(100% - #{$header-height});
  margin: 0px;
  @include flexbox(center-vertical);

  @include ipad(landscape) {
    display: none;
  }
}

.-svg {
  width: 100%;
  height: auto;
}

.panel {
  width: 39%;
  height: 60%;
  text-align: center;
  @include flexbox(column, null, space-between, center);

  @include ipad {
    width: 29%;
  }

  .text {
    margin: 0;
    padding: 0px;
    line-height: 1.3;
    color: $c-shamrock;
  }
}

.next-buttton {
  width: 45px;

  @include ipad {
    width: 70px;
  }
}

</style>
